<template>
  <v-container           align="start"
>
    <mail-recivers></mail-recivers>
    <mail-senders></mail-senders>
  </v-container>
</template>

<script>
import MailRecivers from '../components/MailRecivers'
import MailSenders from '../components/MailSenders'

export default {
  name: 'Mails',
  components: {
    MailRecivers,
    MailSenders
  }
  
  
};
</script>
